import styled, { css } from "styled-components";
import { PARROQUIAS, fromInputDate, parseCSS } from "scripts/FunctionsBundle";
import Input from "./Input";
import { GS } from "App";
import CRUD from "./CRUD";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// SacramentosForms => Rename all instances to use
type SacramentosFormsProps = {
  /** Variable a modificar con los campos. */
  _store: any;
  /** En caso de que el formulario sea de solo lectura. */
  _disabled?: boolean;
  /** Qué sacramento utilizar. */
  _sacramento: "bautizos" | "comuniones" | "confirmaciones" | "matrimonios";
} & _Base;

// ################################ RENDERING COMPONENT ################################
const _SacramentosForms = (props: SacramentosFormsProps) => {
  if (!props._sacramento) return <></>;

  const temptxt =
    props._sacramento === "bautizos"
      ? "l bautizo"
      : props._sacramento === "comuniones"
      ? " la comunión"
      : props._sacramento === "confirmaciones"
      ? " la confirmación"
      : "l matrimonio";
  const tempbool = props._sacramento === "bautizos";

  function hanCh(val: string) {
    const dd = fromInputDate(val);

    if (tempbool) {
      if (props._store.fecha_nacimiento > dd)
        return (
          "La fecha de" +
          temptxt +
          " no puede ser menor a la fecha de nacimiento."
        );
    } else {
      if (props._store.fecha_bautizo > dd)
        return (
          "La fecha de" + temptxt + " no puede ser menor a la fecha de bautizo."
        );
    }
  }

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <>
      {/* ------------------------------------------ ID */}
      <div
        className="fieldset"
        style={{ padding: "0.5em 0.75em", marginTop: "0.5rem" }}
      >
        <Input
          _store={props._store}
          _store_var={"id"}
          _name={"id"}
          _label={"ID (autogenerado):"}
          _width={"s"}
          _disabled
        />
      </div>

      {/* ------------------------------------------------------------------------------------ INFO PRINCIPAL */}
      <fieldset>
        <legend>Información principal</legend>

        {props._sacramento !== "matrimonios" ? (
          <>
            {/* ------------------------------------------ NOMBRE */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"nombre"}
              _name={"nombre"}
              _label={"Nombre:"}
              _preset={"name"}
            />

            {/* ------------------------------------------ SEXO */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"sexo"}
              _name={"sexo"}
              _label={"Sexo:"}
              _preset={"sexo"}
            />

            {props._sacramento === "bautizos" ? (
              <>
                {/* ------------------------------------------ FECHA DE NACIMIENTO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"fecha_nacimiento"}
                  _name={"fecha_nacimiento"}
                  _label={"Fecha de nacimiento:"}
                  _preset={"date"}
                  _onChange={(val: string) => {
                    const dd = fromInputDate(val);
                    if (dd > props._store.fecha_sacramento)
                      return "La fecha de nacimiento no puede ser mayor a la fecha de bautizo.";
                  }}
                />

                {/* ------------------------------------------ CIUDAD DE NACIMIENTO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"ciudad_nacimiento"}
                  _name={"ciudad_nacimiento"}
                  _label={"Ciudad de nacimiento:"}
                  _tooltip={"Ingrese una ciudad o lugar de nacimiento."}
                  _required={"*"}
                />

                {/* ------------------------------------------ FOLIO ACTA DE NACIMIENTO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"folio_acta_nacimiento"}
                  _name={"folio_acta_nacimiento"}
                  _label={"Folio del acta de nacimiento:"}
                  _tooltip={
                    "Folio del acta de nacimiento según como aparezca en el registro civil."
                  }
                  _required={"*"}
                  _width={"s"}
                />
              </>
            ) : (
              <>
                {/* ------------------------------------------ FECHA DE BAUTIZO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"fecha_bautizo"}
                  _name={"fecha_bautizo"}
                  _label={"Fecha de bautizo:"}
                  _preset={"date"}
                  _onChange={(val: string) => {
                    const dd = fromInputDate(val);
                    if (props._store.fecha_sacramento < dd) {
                      const a =
                        props._sacramento === "comuniones"
                          ? "comunión."
                          : "confirmación.";
                      return (
                        "La fecha de bautizo no puede ser mayor a la fecha de " +
                        a
                      );
                    }
                  }}
                  _required={"*"}
                />

                {/* ------------------------------------------ CIUDAD DE BAUTIZO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"ciudad_bautizo"}
                  _name={"ciudad_bautizo"}
                  _label={"Ciudad de bautizo:"}
                  _tooltip={"Ingrese una ciudad o lugar de bautizo."}
                  _width={"l"}
                  _required={"*"}
                />

                {/* ------------------------------------------ PARROQUIA DE BAUTIZO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"parroquia_bautizo"}
                  _name={"parroquia_bautizo"}
                  _label={"Parroquia donde se bautizó:"}
                  _tooltip={"Seleccione una parroquia de la lista."}
                  _select_from={PARROQUIAS}
                  _required={"*"}
                />
              </>
            )}
          </>
        ) : (
          <>
            {/* ------------------------------------------ NOVIO */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"novio"}
              _name={"novio"}
              _label={"Novio:"}
              _preset={"name"}
            />

            {/* ------------------------------------------ NOVIA */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"novia"}
              _name={"novia"}
              _label={"Novia:"}
              _preset={"name"}
            />

            {/* ------------------------------------------ DOMICILIO */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"domicilio"}
              _name={"domicilio"}
              _label={"Domicilio:"}
              _tooltip={"Ingrese un domicilio en cualquier formato."}
              _required={"*"}
            />

            {/* ------------------------------------------ CIUDAD DE MATRIMONIO */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"ciudad_sacramento"}
              _name={"ciudad_sacramento"}
              _label={"Ciudad de matrimonio:"}
              _tooltip={"Ingrese una ciudad o lugar de matrimonio."}
              _required={"*"}
            />
          </>
        )}
      </fieldset>

      {/* ------------------------------------------------------------------------------------ FAMILIARES */}
      <fieldset>
        <legend>Familiares</legend>

        {props._sacramento !== "matrimonios" ? (
          <>
            {/* ------------------------------------------ PADRE */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"padre"}
              _name={"padre"}
              _label={"Padre:"}
              _preset={"name"}
              _required={"-"}
            />
            {/* ------------------------------------------ MADRE */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"madre"}
              _name={"madre"}
              _label={"Madre:"}
              _preset={"name"}
            />

            {props._sacramento === "bautizos" ? (
              <>
                {/* ------------------------------------------ ABUELOS PATERNOS */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"abuelos_paternos"}
                  _name={"abuelos_paternos"}
                  _label={"Abuelos paternos:"}
                  _tooltip={
                    "Nombre completo de los abuelos paternos del bebé, separado con espacios y coma donde sea necesario."
                  }
                  _preset={"two names"}
                />

                {/* ------------------------------------------ ABUELOS MATERNOS */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"abuelos_maternos"}
                  _name={"abuelos_maternos"}
                  _label={"Abuelos maternos:"}
                  _tooltip={
                    "Nombre completo de los abuelos maternos del bebé,\nseparado con espacios y coma donde sea necesario."
                  }
                  _preset={"two names"}
                />

                {/* ------------------------------------------ PADRINO */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"padrino"}
                  _name={"padrino"}
                  _label={"Padrino:"}
                  _preset={"name"}
                />

                {/* ------------------------------------------ MADRINA */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"madrina"}
                  _name={"madrina"}
                  _label={"Madrina:"}
                  _preset={"name"}
                />
              </>
            ) : (
              <>
                {/* ------------------------------------------ PADRINO Y MADRINA */}
                <Input
                  _disabled={props._disabled}
                  _store={props._store}
                  _store_var={"padrino_madrina"}
                  _name={"padrino_madrina"}
                  _label={"Padrino o madrina:"}
                  _preset={"name"}
                />
              </>
            )}
          </>
        ) : (
          <>
            {/* ------------------------------------------ PADRES NOVIO */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"padres_novio"}
              _name={"padres_novio"}
              _label={"Padres del novio:"}
              _preset={"two names"}
            />

            {/* ------------------------------------------ PADRES DE LA NOVIA */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"padres_novia"}
              _name={"padres_novia"}
              _label={"Padres de la novia:"}
              _preset={"two names"}
            />

            {/* ------------------------------------------ TESTIGOS */}
            <CRUD
              _disabled={props._disabled}
              _store={props._store.testigos}
              _store_new={"Nuevo testigo"}
              _create_button={"Agregar testigo"}
              _title={"Testigos:"}
              _input_props={{ _preset: "name" }}
            />
          </>
        )}
      </fieldset>

      {/* ------------------------------------------------------------------------------------ SACRAMENTO */}
      <fieldset>
        <legend>Sacramento</legend>

        {/* ------------------------------------------ FECHA SACRAMENTO */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"fecha_sacramento"}
          _name={"fecha_sacramento"}
          _label={"Fecha de" + temptxt + ":"}
          _preset={"date"}
          _onChange={props._sacramento !== "matrimonios" ? hanCh : undefined}
        />

        {/* ------------------------------------------ PRESBÍTERO */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"presbitero"}
          _name={"presbitero"}
          _label={"Presbítero:"}
          _tooltip={"Seleccione un presbítero de la lista."}
          _select_from={GS.parroquia.presbiteros}
          _preset={"name"}
        />

        {/* ------------------------------------------ LIBRO */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"libro"}
          _name={"libro"}
          _label={"Libro:"}
          _tooltip={"Número del libro donde se encuentra este sacramento."}
          _preset={"int"}
          _range={[1, 15, true]}
          _required={"*"}
        />

        {/* ------------------------------------------ PÁGINA */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"pagina"}
          _name={"pagina"}
          _label={"Página:"}
          _tooltip={"Número de la página donde se encuentra este sacramento."}
          _preset={"int"}
          _range={[1, 9999, true]}
          _required={"*"}
        />

        {/* ------------------------------------------ PARTIDA */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"partida"}
          _name={"partida"}
          _label={"Partida:"}
          _tooltip={
            "Número de la partida o sección dentro de una página donde se encuentra este sacramento."
          }
          _preset={"int"}
          _range={[1, 9999, true]}
          _required={"*"}
        />
      </fieldset>

      {/* ------------------------------------------------------------------------------------ ADICIONAL */}
      <fieldset>
        <legend>Información adicional</legend>

        {props._sacramento === "bautizos" ? (
          <>
            {/* ------------------------------------------ NOTAS MARGINALES */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"notas_marginales"}
              _name={"marginales"}
              _label={"Notas marginales aplicables:"}
              _type={"textarea"}
            />
          </>
        ) : props._sacramento === "matrimonios" ? (
          <>
            {/* ------------------------------------------ PRESENTACIÓN */}
            <Input
              _disabled={props._disabled}
              _store={props._store}
              _store_var={"presentacion"}
              _name={"presentacion"}
              _label={"Presentación matrimonial:"}
              _tooltip={"Presentación matrimonial o anotaciones particulares."}
              _required={"*"}
            />
          </>
        ) : (
          <></>
        )}

        {/* ------------------------------------------ NOTAS */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"notas"}
          _name={"notas"}
          _label={"Notas adicionales:"}
          _tooltip={
            "Notas extras o consideraciones específicas para este registro."
          }
          _type={"textarea"}
        />
      </fieldset>
    </>
  );
};

// ################################ STYLES ################################
const SacramentosForms = styled(_SacramentosForms).attrs(
  (props: SacramentosFormsProps): SacramentosFormsProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default SacramentosForms;
